exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.underlineError {\n    text-decoration: underline;\n    -webkit-text-decoration-color: red; /* safari still uses vendor prefix */\n    text-decoration-color: red;\n}\n.toasted-container .toasted {\n    height: 60px !important;\n}\ndiv.toasted.outline {\n    border: 3px solid #008dd2 !important;\n}\n.desc {\n    font-size: 18px;\n}\n", ""]);

// exports
